import React from "react";
import TableGeneric from "../../../../../shared/components/generic/table/table-generic";
import InlineAlert from "../../../../../shared/components/generic/alert/inline-alert/inline-alert";
import MonetaryUtils from "../../../../../shared/utils/MonetaryUtils";
import "./assessment-rules-content.css";

const assessmentRulesColumns = [
	{
		key: "goal",
		label: "Crescimento",
		render: row =>
			MonetaryUtils.formatPercentage(row.goal) || "-"
	},
	{
		key: "netSales",
		label: "Net Sales",
		render: row =>
			MonetaryUtils.formatCurrency(row.netSales) || "-"
	},
	{
		key: "discountPercentage",
		label: "% Desconto nas parcelas",
		render: row => (
			<strong className="assessment-rules-content__discount">
				{MonetaryUtils.formatPercentage(
					row.discountPercentage
				) || "-"}
			</strong>
		)
	}
];

const AssessmentRulesContent = ({ rules = [] }) => {
	const currentRules = Array.isArray(rules) ? rules : [];

	return (
		<div className="assessment-rules-content">
			{currentRules.length > 0 ? (
				<TableGeneric
					columns={assessmentRulesColumns}
					data={currentRules}
					rowKey="id"
				/>
			) : (
				<InlineAlert
					variant="info"
					message="Nenhuma meta ou regra disponível para esta apuração."
				/>
			)}
		</div>
	);
};

export default AssessmentRulesContent;